/** CSS variables consumed by `body #root .alert` in index.scss. */
export const HEALTH_RESUME_OFFSET_VAR = '--kronos-health-resume-offset';
export const HEALTH_RESUME_Z_VAR = '--kronos-health-resume-z';

/** Default `bottom` of fixed toasts (`body #root .alert`). */
const TOAST_BOTTOM_PX = 7;

/** Gap between the top of the health-check card and the bottom of a toast. */
const STACK_GAP_PX = 12;

/** Lift toasts above the warning card (z-index 1001) so its shadow does not cover them. */
const TOAST_Z_BOOST = 2;

/**
 * Extra `bottom` (px) so a fixed toast sits above the health-check warning card.
 *
 * @param {number} rect_top  Card top, viewport coordinates
 * @param {number} viewport_height
 * @returns {number}
 */
export function health_resume_toast_offset_px(rect_top, viewport_height) {
    if (!Number.isFinite(rect_top) || !Number.isFinite(viewport_height))
        return 0;
    return Math.max(0, Math.ceil(viewport_height - rect_top + STACK_GAP_PX - TOAST_BOTTOM_PX));
}

/**
 * Publish the offset while the resume card is on screen. Clears it when hidden.
 *
 * @param {Element|null|undefined} node
 */
export function publish_health_resume_toast_offset(node) {
    if (typeof document === 'undefined')
        return;
    if (!node || typeof node.getBoundingClientRect !== 'function') {
        clear_health_resume_toast_offset();
        return;
    }
    const rect = node.getBoundingClientRect();
    if (rect.height <= 0) {
        clear_health_resume_toast_offset();
        return;
    }
    const offset = health_resume_toast_offset_px(rect.top, window.innerHeight);
    document.documentElement.style.setProperty(HEALTH_RESUME_OFFSET_VAR, `${offset}px`);
    document.documentElement.style.setProperty(HEALTH_RESUME_Z_VAR, String(TOAST_Z_BOOST));
}

export function clear_health_resume_toast_offset() {
    if (typeof document === 'undefined')
        return;
    document.documentElement.style.removeProperty(HEALTH_RESUME_OFFSET_VAR);
    document.documentElement.style.removeProperty(HEALTH_RESUME_Z_VAR);
}
